export default {
  inserted: function(el, binding) {
    el.style.visibility = binding.value ? "visible" : "hidden";
  },
  update: function(el, binding) {
    el.style.visibility = binding.value ? "visible" : "hidden";
  }
};
